document.addEventListener("DOMContentLoaded", function() {
  // Change button text on product page from "Buy it now"
  // (Set multiple timeouts because it is uncertain when the text is set to "Buy it now")
  setTimeout(() => {
    document.querySelector('button.shopify-payment-button__button').innerText = 'Lease mij';
  }, 2000);
  setTimeout(() => {
    document.querySelector('button.shopify-payment-button__button').innerText = 'Lease mij';
  }, 3000);
  setTimeout(() => {
    document.querySelector('button.shopify-payment-button__button').innerText = 'Lease mij';
  }, 4000);
  setTimeout(() => {
    document.querySelector('button.shopify-payment-button__button').innerText = 'Lease mij';
  }, 5000);
  setTimeout(() => {
    document.querySelector('button.shopify-payment-button__button').innerText = 'Lease mij';
  }, 10000);

  // Change button text on product page from "Toevoegen aan winkelwagen"
  document.querySelector('button.ProductForm__AddToCart').innerText = 'Toevoegen aan bestelling';
});

